import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import React, {useState} from "react";
import CreateIcon from "@mui/icons-material/Create";
import AddIcon from "@mui/icons-material/Add";
import {displayMod} from "../../_helper/displayMod";
import {s_char_weapons} from "../../_signals/s_char";
import {useSignals} from "@preact/signals-react/runtime";
import WeaponsEdit from "./WeaponsEdit";
import WeaponsAdd from "./WeaponsAdd";
import {ICharWeapon} from "../../_interfaces/ICharWeapon";


function Weapons() {
    useSignals()

    const [edit, setEdit] = useState('')
    const [add, setAdd] = useState(false)

    const weaponsRow = (row:ICharWeapon) => {
        return <TableRow key={row.id}>
            <TableCell style={{width: '65%'}}>
                <div>{row.name}</div>
                {row.wield ? <div>ausgerüstet</div> : null}
                {row.descr ? <div style={{fontStyle: 'italic'}}>Bem: {row.descr}</div> : null}
            </TableCell>
            <TableCell style={{width: '15%'}}>
                {row.type === 'close' ? 'Nahkampf' : "Fernkampf"}
            </TableCell>
            <TableCell style={{width: '20%'}}>
                {row.dmg + ' +' + row.attribute + displayMod(row.dmg_mod)} ({row.dmg + row.dmg_mod})
            </TableCell>
            <TableCell style={{width: '1%', paddingRight: 0}}>
                <Button className={'btn'} id="post" onClick={() => setEdit(row.id)}>
                    <CreateIcon/>
                </Button>
            </TableCell>
        </TableRow>
    }

    return <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
        <h3 style={{margin: "5px",display:'flex',justifyContent:'space-between'}}>
            <span>Waffen</span>
            <AddIcon onClick={() => setAdd(true)}/>
        </h3>
        <TableContainer style={{maxHeight: 185}}>
            <Table stickyHeader style={{width: '100%'}}>
                <TableHead>
                    <TableRow>
                        <TableCell>Was</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Schaden</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>{s_char_weapons.value.map((row) => weaponsRow(row))}</TableBody>
            </Table>
        </TableContainer>
        <WeaponsEdit edit={edit} isOpen={setEdit}></WeaponsEdit>
        <WeaponsAdd add={add} isOpen={setAdd}></WeaponsAdd>
    </Paper>
}

export default Weapons;
